import { render, staticRenderFns } from "./DisplayProductSlider.vue?vue&type=template&id=9e6a7fc6&name=display-product-slider&"
import script from "./DisplayProductSlider.vue?vue&type=script&lang=js&"
export * from "./DisplayProductSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports